export class AlertPromptBase<T> {
  titleTC?: string;
  subtitleTC?: string;
  cancelTextTC?: string;
  continueTextTC?: string;
}
